import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				display: "flex",
				justifyContent: "space-between",
				width: "100%",
				paddingBottom: 10,
				fontSize: 14,
				color: theme.palette.secondary.contrastText
			},
			title: {
				color: theme.palette.grey[300]
			},
			textQuatity: {
				fontSize: 16,
				fontWeight: 700,
				color: theme.palette.grey[300]
			}
		}),
	{
		name: "FooterItem",
		index: 1
	}
);

export default useStyles;
